import { array, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = partial({
	pageNumbers: array(iotsUtils.PositiveInteger1Based),
});
